import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { reduxForm, Field, formValueSelector } from 'redux-form'
import labelAndInput from '../common/form/labelAndInput'

import ContentHeader from '../common/template/contentHeader'
import Content from '../common/template/content'

import Tabs from '../common/tab/tabs'
import TabsHeader from '../common/tab/tabsHeader'
import TabsContent from '../common/tab/tabsContent'
import TabHeader from '../common/tab/tabHeader'
import TabContent from '../common/tab/tabContent'
import { reset as resetForm, initialize } from "redux-form";

import If from '../common/operador/if'
import { init, salvar } from './configuracaoAction'



class ConfiguracaoForm extends Component {

  componentWillMount() {
    this.props.init()
  }


  onSubmit = (e) => {
    e.preventDefault();
    this.props.salvar({_path_save_pdf:  this.path_save_pdf.value,
      _path_arquivo_log_gera_pdf: this.path_arquivo_log_gera_pdf.value})
}
  

  render() {

    return (
      <div>
        <ContentHeader title='Configurações' small='' />
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label='Configurações' icon='cog' target='config' />
            </TabsHeader>
            <TabsContent>
              <TabContent id='config'>
                <div>
                
                  <form role='form' >

                    <div className="box-body">

                      <Field name='path_save_pdf' component={labelAndInput}
                        label='Path para salvar PDF'
                        cols='12 12'
                        placeholder='Path para salvar PDF da geração automática de carne'
                        onChange={this.chageValorPDF} ref={(c) => this.path_save_pdf = c} />

                      <Field name='path_arquivo_log_gera_pdf' component={labelAndInput}
                        type='text' cols='12 12'
                        label='Path Log' placeholder='Log da geração automática de carne' 
                        onChange={this.chageValorLog}  ref={(c) => this.path_arquivo_log_gera_pdf = c} />

                    </div>
                    <div className="boxfooter">

                      <button type='button'
                        className={`btn btn-primary`}>
                        <i className={`fa fa-save`}></i>
                        <span className='space-icon'
                        onClick={this.onSubmit} >Salvar</span>
                      </button>

                    </div>
                  </form>
                </div>
              </TabContent>

            </TabsContent>
          </Tabs>
        </Content>
      </div>)
  }
}

ConfiguracaoForm = reduxForm({ form: 'configuracaoForm', destroyOnUnmount: false })(ConfiguracaoForm)
const selector = formValueSelector('configuracaoForm')
const mapStateToProps = state => ({ configuracao: state.configuracao, usuario: state.auth.user })
const mapDispatchToProps = dispatch => bindActionCreators({ init, salvar }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ConfiguracaoForm)





// WEBPACK FOOTER //
// ./src/configuracoes/configuracao.jsx